<div class="billing-dialog fs-16">
  <div class="billing-dialog__img-container flex-center">
    <img
      class="billing-dialog__img"
      [src]="
        showWarningPage ? images?.CASH_DRAWER_WARNING : images?.CASHIER_SET_UP
      "
      alt="cashier set up"
    />
    <img
      class="billing-dialog__img--cross img-32 c-pointer"
      [src]="images?.CLOSE_ICON"
      alt="cancel"
      (click)="closeModal()"
    />
  </div>

  <div class="billing-dialog__content ta_center">
    <div class="billing-dialog__title clr-333 fw-700 lh-130">
      {{
        (showWarningPage
          ? 'COUNTER_SET_UP_MODAL.UNABLE_TO_ACCESS_CASH_DRAWER'
          : 'COUNTER_SET_UP_MODAL.SET_UP_YOUR_BILLING_COUNTERS'
        ) | fallbackTranslate
      }}
    </div>
    <div class="billing-dialog__message clr-666 fw-400 lh-140">
      {{
        (showWarningPage
          ? 'COUNTER_SET_UP_MODAL.YOU_CAN_ONLY_ACCESS_CASH_DRAWER_ON_APP'
          : 'COUNTER_SET_UP_MODAL.NO_CASH_DRAWER_RECEIPT_PRINTER_HAS_BEEN_MAPPED'
        ) | fallbackTranslate
      }}
    </div>
    <button
      class="billing-dialog__button wd-100 color-white fw-700 lh-140"
      (click)="handleBtnClick()"
    >
      {{
        (showWarningPage
          ? 'COUNTER_SET_UP_MODAL.OKAY_GOT_IT'
          : 'COUNTER_SET_UP_MODAL.CLICK_HERE_TO_SET_UP'
        ) | fallbackTranslate
      }}
    </button>
  </div>
</div>
